import { RouterProvider } from "react-router";
import { publicRouter } from "./public_router";

/**
 * Minimal shell for the public section (see `public_router.tsx`): no
 * sidebar, no tenant switcher, no auth wrapper — just the theme providers
 * from `main.tsx` and the public routes.
 */
export default function PublicShell() {
  return <RouterProvider router={publicRouter} />;
}
